import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
`;

export const Content = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(50%, 2fr));
    grid-gap: 0;
    @media screen and (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(100%, 2fr));
    }
`;